import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles({
    popup: {
        '& p': {
            color: 'black',
        },
    },
    error: {
        '& .MuiInputBase-root': {
            '& .MuiInputBase-input': {
                color: '#f44336',
            },
            '& .MuiOutlinedInput-notchedOutline': {
                borderColor: '#f44336',
            },
            '&:hover .MuiOutlinedInput-notchedOutline': {
                borderColor: '#f44336',
            },
        },
    },
});
